/* Public layout — used for landing, login, register, policies. Authenticated
   app uses MemberLayout (left sidebar). */
import React, { useState } from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X, Trees } from "lucide-react";

export default function Layout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const onLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--hh-bg)" }}>
      <header className="glass-header sticky top-0 z-50">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to={user ? "/profile" : "/"} className="flex items-center gap-2" data-testid="header-logo">
            <Trees size={22} color="var(--hh-accent)" />
            <span className="font-display text-2xl">Nomad <span className="text-[var(--hh-accent)]">Life</span></span>
          </Link>
          <div className="hidden md:flex items-center gap-3">
            {user ? (
              <>
                <Link to="/profile" className="btn-primary" data-testid="header-enter-app">Enter the community</Link>
                <button onClick={onLogout} className="btn-ghost" data-testid="header-logout-btn">Sign out</button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn-ghost" data-testid="header-login-link">Sign in</Link>
                <Link to="/#pricing" className="btn-primary" data-testid="header-register-link">Join the journey</Link>
              </>
            )}
          </div>
          <button className="md:hidden text-[var(--hh-cream)]" onClick={() => setOpen(v => !v)} data-testid="mobile-menu-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
        {open && (
          <div className="md:hidden border-t border-[var(--hh-border)] px-6 py-4 flex flex-col gap-3">
            {user ? (
              <>
                <Link to="/profile" onClick={() => setOpen(false)} className="btn-primary">Enter the community</Link>
                <button onClick={onLogout} className="btn-ghost mt-2">Sign out</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="btn-ghost">Sign in</Link>
                <Link to="/#pricing" onClick={() => setOpen(false)} className="btn-primary">Join the journey</Link>
              </>
            )}
          </div>
        )}
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-[var(--hh-border)] mt-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between text-sm text-[var(--hh-sage)]">
          <div className="flex items-center gap-2 font-display text-xl text-[var(--hh-cream)]">
            <Trees size={18} color="var(--hh-accent)" /> Nomad Life
          </div>
          <p>© {new Date().getFullYear()} — A community for nomads choosing where to land.</p>
          <nav className="flex gap-5 text-xs label-eyebrow" data-testid="footer-legal-nav">
            <Link to="/guides" className="link-hh" data-testid="footer-guides-link">Guides</Link>
            <Link to="/terms" className="link-hh" data-testid="footer-terms-link">Terms</Link>
            <Link to="/privacy" className="link-hh" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/cookies" className="link-hh" data-testid="footer-cookies-link">Cookies</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
